import React from "react";
import PropTypes from "prop-types";

import Str from "shared/components/Str";

import "./BoostReportHeader.scss";

const BoostReportHeader = ({ isBoosting, isExpanded, onToggle, onClose }) => (
	<div className="boost-report-toggler">
		<button className="boost-report-toggler-inner" onClick={onToggle}>
			<span className="icon i-boost" />
			<Str>Boost Activity</Str>
			{isExpanded ? (
				<span className="action icon i-minimize" />
			) : (
				<span className="action icon i-maximize" />
			)}
		</button>
		{!isBoosting && (
			<button
				className="boost-report-toggler-close"
				onClick={(event) => {
					event.preventDefault();
					onClose();
				}}
			>
				<span className="close">
					<span className="okicon i-close" />
				</span>
			</button>
		)}
	</div>
);

BoostReportHeader.propTypes = {
	isBoosting: PropTypes.bool.isRequired,
	isExpanded: PropTypes.bool.isRequired,
	onToggle: PropTypes.func.isRequired,
	onClose: PropTypes.func.isRequired,
};

export default BoostReportHeader;



// WEBPACK FOOTER //
// ./src/apps/notifications_footer/components/BoostReportHeader.jsx